import { render, staticRenderFns } from "./unsaved-dialog.vue?vue&type=template&id=3384e677&"
import script from "./unsaved-dialog.vue?vue&type=script&lang=js&"
export * from "./unsaved-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports